
import "../Services.css";
import DeskImage from "../../Assets/Images/USA.jpg";
import FAQSection from "./UsaFAQs.js";

const App = () => {
  return (
    <section id="services" className="service-page">
      <div className="container">
        <div className="service-hero">
          <div className="hero-text">
            <h1>Start Smart: Seamless USA Company Formation!</h1>
            <p className="hero-subtitle">LLC and C-Corp setup, EIN, Registered Agent, and banking guidance for global founders.</p>
          </div>
          <div className="hero-media">
            <img src={DeskImage} alt="USA Company Formation" className="desk-image" />
          </div>
        </div>
      </div>
      <FAQSection />
    </section>
  );
};

export default App;
